/**
 * Keeps leading zeros; an empty string is what react-admin reads as "no
 * filter".
 */
export function digitsOnly(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).replace(/\D+/g, '');
}

export default digitsOnly;
